

export const Routes = {
    Default: {
        path: "/"
    },
    Login: {
        path: "/login"
    },
    Dashboard: {
        path: "/dashboard"
    },

    Manager: {
        path: "/manager"
    },
    Employee: {
        path: "/employee"
    },
    StaffAttendence: {
        path: "/staff-attendance"
    },
    AttendenceReport: {
        path: "/attendance-report"
    },
    EmployeeAttendence: {
        path: "/employee-attendance"
    },
    EmployeeAttendenceReport: {
        path: "/employee-attendance-report"
    },
    EmployeeDetails: {
        path: "/employee-details"
    },
  
    Supplier: {
        path: "/supplier"
    },
    Unloading: {
        path: "/unloading"
    },
    WashingArea: {
        path: "/washing-area"
    },
    ProcessingWashing: {
        path: "/processing-washing"
    },
    Rework: {
        path: "/rework"
    },
    Refrigeration: {
        path: "/refrigeration"
    },
    PackingWashing: {
        path: "/packing-washing"
    },
    GreenRoom: {
        path: "/green-room"
    },
    RejectionLog: {
        path: "/rejection"
    },
    ForgotPassword: {
        path: "/forgot-password"
    },
    CreatePassword: {
        path: "/create-password"
    },
    ResetPassword: {
        path: "/reset-password"
    },
    ReceivingDashboard: {
        path: "/receiving-dashboard"
    },
    RipeningDashboard: {
        path: "/ripening-dashboard"
    },
    ProcessingDashboard: {
        path: "/processing-dashboard"
    },
    Processing: {
        path: "/processing"
    },
    Cooking: {
        path: "/cooking"
    },
    PackingDashboard: {
        path: "/packing-dashboard"
    },
    Packing: {
        path: "/packing"
    },
    Bagging: {
        path: "/bagging"
    },
    PackingSorting: {
        path: "/packing-sorting"
    },
    ReworkDashboard: {
        path: "/rework-dashboard"
    },
    Humid: {
        path: "/humid"
    },
    ReworkRefrigeration: {
        path: "/rework-refrigeration"
    },
    ColdStorage: {
        path: "/cold-storage"
    },
    RipeningRoom: {
        path: "/ripening-room"
    },
    Sorting: {
        path: "/sorting"
    },
    RipeningWashing: {
        path: "/ripening-washing"
    },
    BrokerageDashboard: {
        path: "/brokerage-dashboard"
    },
    MaterialEntered: {
        path: "/material-entered"
    },
    PackingAndSorting: {
        path: "/packing-and-sorting"
    },
    BrokerageSorting: {
        path: "/brokerage-sorting"
    },
    BrokeragePacking: {
        path: "/brokerage-packing"
    },
    BrokerageRefrigeration: {
        path: "/brokerage-refrigeration"
    },
    RefrigerationArea: {
        path: "/refrigeration-area"
    },
    Billcreation: {
        path: "/bill-creation"
    },
    BillReportid: {
        path: "/bill-report/:id" 
    },
    BillListing: {
        path: "/bill-listing"
    },
    BillingReport: {
        path: "/bill-report"
    },
    ExpenseDashboard: {
        path: "/expense-dashboard"
    },
    GasConsumption: {
        path: "/gas-consumtion"
    },
    RolePermission: {
        path: "/role-and-permission"
    },
    ReworkPacking: {
        path: "/rework-packing"
    },
    Toasted: {
        path: "/toasted"
    },
    BrokerageTurn2: {
        path: "/turn-2"
    },
    Mixing: {
        path: "/mixing"
    },
    Pasting: {
        path: "/pasting"
    },
    PastingDashboard: {
        path: "/pasting-dashboard"
    },
}